export function nl2br(str: string): JSX.Element[] {
  return str.split(/\r?\n/g).map((line) => <>{line}<br /></>);
}
